module.exports = __webpack_public_path__ + "img/lukscolor.d35adc38.jpg";